module.exports = __webpack_public_path__ + "static/media/redfish2.abb5f15c.png";